import { render, staticRenderFns } from "./DlgInfoBar.vue?vue&type=template&id=4a9f2572&scoped=true"
import script from "./DlgInfoBar.vue?vue&type=script&lang=js"
export * from "./DlgInfoBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9f2572",
  null
  
)

export default component.exports